/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ArchitectsControllerUpdateMutationRequest, ArchitectsControllerUpdateMutationResponse, ArchitectsControllerUpdatePathParams, ArchitectsControllerUpdate400, ArchitectsControllerUpdate401, ArchitectsControllerUpdate403, ArchitectsControllerUpdate404 } from "../../models/architectsController/ArchitectsControllerUpdate";

function getArchitectsControllerUpdateUrl(id: ArchitectsControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/architects/${id}` as const }  
  return res
}

/**
 * @summary Update an architect
 * {@link /api/v1/architects/:id}
 */
export async function architectsControllerUpdate(id: ArchitectsControllerUpdatePathParams["id"], data?: ArchitectsControllerUpdateMutationRequest, config: Partial<RequestConfig<ArchitectsControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ArchitectsControllerUpdateMutationResponse, ResponseErrorConfig<ArchitectsControllerUpdate400 | ArchitectsControllerUpdate401 | ArchitectsControllerUpdate403 | ArchitectsControllerUpdate404>, ArchitectsControllerUpdateMutationRequest>({ method : "PATCH", url : getArchitectsControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}